import {
    SEND_VERIFICATION_SMS_START,
    SEND_VERIFICATION_SMS_SUCCESS,
    SEND_VERIFICATION_SMS_ERROR
} from '../../constants';
import getPhoneData from '../../components/PhoneVerificationModal/getUserData.graphql';
import { openSmsVerificationModal } from '../SmsVerification/modalActions';
import { processSms } from '../../core/sms/processSms';
import { decode } from '../../helpers/queryEncryption';
import { setLoaderStart, setLoaderComplete } from '../loader/loader';
import showErrorMessage from '../../helpers/showErrorMessage';
import { addPhoneNumber as mutation } from '../../lib/graphql';

export function sendVerificationSms(countryCode, phoneNumber, countryName, userId) {

    return async (dispatch, getState, { client }) => {
        try {
            dispatch({
                type: SEND_VERIFICATION_SMS_START,
            });
            dispatch(setLoaderStart('smsLoading'));

            const { data } = await client.mutate({
                mutation,
                variables: {
                    countryCode,
                    phoneNumber,
                    countryName,
                    userId
                },
                refetchQueries: [{
                    query: getPhoneData, variables: { userId: userId }
                }]
            });

            if (data?.AddPhoneNumber?.status == '200') {
                const { status, errorMessage } = await processSms('verification',
                    data.AddPhoneNumber.countryCode,
                    decode(data.AddPhoneNumber.phoneNumber),
                    data.AddPhoneNumber.userProfileNumber);

                if (status == 200) {
                    dispatch(openSmsVerificationModal('verifyPhoneNumber'));
                    dispatch({
                        type: SEND_VERIFICATION_SMS_SUCCESS,
                    });
                } else {
                    dispatch({
                        type: SEND_VERIFICATION_SMS_ERROR,
                    });
                }

                dispatch(setLoaderComplete('smsLoading'));

                if (errorMessage) {
                    return {
                        status: '400',
                        errorMessage
                    }
                }
            } else {
                dispatch({
                    type: SEND_VERIFICATION_SMS_ERROR,
                });

                dispatch(setLoaderComplete('smsLoading'));

                return {
                    status: '400',
                    errorMessage: showErrorMessage({ errorCode: 'commonError' })
                };
            }
        } catch (error) {
            dispatch({
                type: SEND_VERIFICATION_SMS_ERROR,
            });
            dispatch(setLoaderComplete('smsLoading'));
            return {
                status: '400'
            };
        }
        return {
            status: '200'
        };
    };
}